'use strict';

var _ = require('lodash');

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function wrapReduxConnectedComponent(component, store) {
    var React = require('react'),
        Provider = require('react-redux').Provider,
        createStore = require('redux').createStore;

    return React.createElement(
        Provider,
        { store: createStore(function (state) {
                return state;
            }, store) },
        component
    );
}

function getConnectedReduxComponent(comp, mapStateToProps, mapDispatchToProps) {

    var ReactRedux = require("react-redux");

    var _extends = function _extends(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                target[key] = source[key];
            }
        }

        return target;
    };

    exports.baseComponent = comp;
    exports['default'] = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(comp);

    return _extends(exports['default'], exports);
}

function isStringImagePath(string) {
    var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    //var regex = new RegExp(expression);

    return expression.test(string);
}
/**
 *
 * @param {String/Array} Class names
 * @returns {string}
 */
function toClassString() {
    return _.flattenDeep(arguments).join(' ');
}

function filterTargetFromSourceById(suggested, selected, unique_id_field) {
    //N coplexety

    var newSuggested = [];

    var selectedIdToIndex = {};
    for (var selectedIndex in selected) {
        var unique_id = selected[selectedIndex][unique_id_field];
        selectedIdToIndex[unique_id] = parseInt(selectedIndex);
    }

    for (var suggestedIndex in suggested) {
        var suggestedItem = suggested[suggestedIndex];
        if (selectedIdToIndex[suggestedItem[unique_id_field]] == undefined) {
            newSuggested.push(suggestedItem);
        }
    }

    return newSuggested;
}

/**
 * Format decimal numbers
 * @param {number} number Number to format
 * @param {number|object} config Number of decimal places to show, or a configuration object with possible options: decimalPlaces, showZero
 * @returns {string}
 */
function limitDecimal() {
    var num = arguments[0];

    if (_.isObject(arguments[1])) {
        var config = arguments[1];

        var res = parseFloat(Math.round(num * 100) / 100).toFixed(config.decimalPlaces);

        return config.showZero ? res.replace(/\.?0*$/, '') : res;
    } else {
        var decimal = arguments[1];
        return parseFloat(Math.round(num * 100) / 100).toFixed(decimal);
    }
}

/**
 * Get number in a giver range
 * @param {number} num The number to test
 * @param {number} min The minimal number in allowed range
 * @param {number} max The maximal number in allowed range
 * @returns {number}
 */
function numberInRange(num, min, max) {
    return num >= max ? max : num <= min ? min : num;
}

function getCookie(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
}

function setCookie(cookie, extraDays) {
    var date = new Date();
    var days = extraDays;
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires = " + date.toUTCString();
    document.cookie = cookie + ";" + expires + ";";
}

function trackEvent(params, outbound) {
    if (typeof ga !== 'undefined') {
        if (getCookie("checkbox_analytics") != "no") {
            var payload = {
                hitType: 'event',
                eventCategory: params.category ? params.category : "default category",
                eventAction: params.action ? params.action : "default action",
                eventLabel: params.label ? params.label : "default label",
                eventValue: params.value ? params.value : 0
            };

            var payloadForGA4 = {
                hitType: 'event',
                event_category: params.category ? params.category : "default category",
                event_label: params.label ? params.label : "default label",
                value: params.value ? params.value : 0
            };
            var event_action = params.action ? params.action : "default action";

            if (typeof outbound === "function") {
                payload.hitCallback = outbound;
                payloadForGA4.hitCallback = outbound;
            } else if (typeof outbound === "string") {
                payload.hitCallback = function () {
                    document.location = outbound;
                };
            }

            ga('send', payload);

            if (typeof gtag !== 'undefined') {
                gtag('event', event_action, payloadForGA4);
            }
        }
    } else {
        console.log("track event called but ga undefined", params, outbound);
        if (typeof outbound === "function") {
            outbound();
        } else if (typeof outbound === "string") {
            document.location = outbound;
        }
    }
}

module.exports = {
    guid: guid,
    trackEvent: trackEvent,
    wrapReduxConnectedComponent: wrapReduxConnectedComponent,
    getConnectedReduxComponent: getConnectedReduxComponent,
    isStringImagePath: isStringImagePath,
    toClassString: toClassString,
    filterTargetFromSourceById: filterTargetFromSourceById,
    limitDecimal: limitDecimal,
    numberInRange: numberInRange,
    getCookie: getCookie,
    setCookie: setCookie
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/libs/utils.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30